<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Timeline">Timeline</a></h2>
<h2 class="toc1t"><a href="#/xhtml/07_Chapter_1"><span class="tochang">Chapter 1:</span> Medieval Origins (14th–15th centuries)</a></h2>
<h2 class="toc1"><span href="#/xhtml/08_Chapter_2" title="Link target outside of Sample"><span class="tochang">Chapter 2:</span> The Renaissance (16th–17th centuries)</span></h2>
<h2 class="toc1"><span href="#/xhtml/09_Chapter_3" title="Link target outside of Sample"><span class="tochang">Chapter 3:</span> The Age of Reason (18th century)</span></h2>
<h2 class="toc1"><span href="#/xhtml/10_Chapter_4" title="Link target outside of Sample"><span class="tochang">Chapter 4:</span> The Wars of Napoleon (1792–1815)</span></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter_5" title="Link target outside of Sample"><span class="tochang">Chapter 5:</span> The Industrial Age (1815–1914)</span></h2>
<h2 class="toc1"><span href="#/xhtml/12_Chapter_6" title="Link target outside of Sample"><span class="tochang">Chapter 6:</span> World War I (1914–1918)</span></h2>
<h2 class="toc1"><span href="#/xhtml/13_Chapter_7" title="Link target outside of Sample"><span class="tochang">Chapter 7:</span> World War II and After (1919–present)</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?cac87cea